import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as LoadingVehicleIcon } from 'src/Images/icons/vehicle-tracking/create-delivery-empty-state.svg';
import CreateLoadForVehicleTrackingPlanning from 'src/components/VehicleTrackingCreate/Outward/VehicleTrackingPlanning/CreateLoadForVehicleTrackingPlanning';
import 'src/style/createVehicleTracking.css';

function AttachLoadToVehicleTrackingPlanning({
  formData,
  selectedDeliveryOrder,
  showCreateLoadForm,
  setShowCreateLoadForm,
  loadLineItems,
  setLoadLineItems,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;

  useEffect(() => {
    if (!showCreateLoadForm) return;

    setLoadLineItems((prev) => {
      const selectedDeliveryList = selectedDeliveryOrder || [];
      const selectedDeliveryIds = new Set(
        selectedDeliveryList.map((item) => item.delivery_id),
      );
      const syncedLoadLineItems = prev.filter((item) =>
        selectedDeliveryIds.has(item.delivery_id),
      );
      const existingIds = new Set(
        syncedLoadLineItems.map((item) => item.delivery_id),
      );
      const selectedDeliveriesToAdd = selectedDeliveryList.filter(
        (deliveryObj) => !existingIds.has(deliveryObj.delivery_id),
      );
      const nextLoadLineItems = selectedDeliveriesToAdd.length
        ? [...syncedLoadLineItems, ...selectedDeliveriesToAdd]
        : syncedLoadLineItems;

      const isUnchanged =
        nextLoadLineItems.length === prev.length &&
        nextLoadLineItems.every((item, index) => item === prev[index]);

      return isUnchanged ? prev : nextLoadLineItems;
    });
  }, [selectedDeliveryOrder, setLoadLineItems, showCreateLoadForm]);

  if (showCreateLoadForm) {
    return (
      <CreateLoadForVehicleTrackingPlanning
        formData={formData}
        selectedDeliveryOrder={selectedDeliveryOrder}
        loadLineItems={loadLineItems}
        setLoadLineItems={setLoadLineItems}
        onBack={() => setShowCreateLoadForm(false)}
      />
    );
  }

  return (
    <div className="create-form-container">
      <div
        className={`theme-scrollable-container-${themeColor} scrollable-container col-container`}
      >
        <div className="container-card-shadow border-radius-4 min-height-20vh margin-top-10">
          <div className="h-100 div-flex-column div-flex-center div-align-center">
            <LoadingVehicleIcon />
            <span className="text-grey text-xxl text-semi-bold">
              Create Load
            </span>
            <span className="text-grey text-sm">
              Plan your delivery by making loads.
            </span>
            <span className="text-grey text-sm">
              You can start by creating one or multiple loads.
            </span>
            <div className="div-flex-row py-3">
              <button
                className={`common-btn theme-background-${themeColor}`}
                type="button"
                onClick={() => setShowCreateLoadForm(true)}
              >
                Create Load
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttachLoadToVehicleTrackingPlanning;
